export default function PlayIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="27"
      viewBox="0 0 24 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_288_1348)">
        <path
          d="M11.2081 12.8718L0.0993652 24.716C0.224115 25.166 0.448294 25.5809 0.754766 25.9291C1.06124 26.2773 1.44189 26.5496 1.86762 26.7252C2.29335 26.9008 2.75289 26.9749 3.21111 26.9421C3.66934 26.9092 4.11411 26.7702 4.51143 26.5355L17.0108 19.291L11.2081 12.8718Z"
          fill="#EA4335"
        />
        <path
          d="M22.441 10.8585L17.0358 7.70776L10.9517 13.1412L17.0606 19.2739L22.4246 16.157C22.8998 15.9037 23.2978 15.523 23.5755 15.056C23.8532 14.589 24 14.0535 24 13.5077C24 12.9618 23.8532 12.4263 23.5755 11.9593C23.2978 11.4923 22.8998 11.1116 22.4246 10.8584L22.441 10.8585Z"
          fill="#FBBC04"
        />
        <path
          d="M0.099404 2.24072C0.0322971 2.49335 -0.00112731 2.75401 2.90029e-05 3.01571V23.9409C0.000691635 24.2025 0.0340852 24.463 0.099404 24.716L11.5889 13.1751L0.099404 2.24072Z"
          fill="#4285F4"
        />
        <path
          d="M11.2909 13.4784L17.0357 7.70798L4.55287 0.429621C4.0832 0.149718 3.54904 0.00148125 3.00477 5.8513e-06C1.65412 -0.00266553 0.466678 0.90961 0.0993652 2.23242L11.2909 13.4784Z"
          fill="#34A853"
        />
      </g>
      <defs>
        <clipPath id="clip0_288_1348">
          <rect width="24" height="27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
